module.exports = __webpack_public_path__ + "img/category_18.43a8924e.png";